module.exports = __webpack_public_path__ + "static/media/photostickomni-256.fc636a98.png";